export const Select = 'atlantis-select';
export const SelectMulti = 'atlantis-select-multi';
export const SelectAsync = 'atlantis-select-async';
export const SelectAsyncMulti = 'atlantis-select-async-multi';
